<template>
    <main>
        <div class="container-fluid">
            <div class="row">
                <div class="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                    <div class="mainButton">
                        <breadcrumbs></breadcrumbs>
                    </div>
                    <div class="page-toolbar">
                        <div class="page-title">
                            <span class="title">Funders</span>
                            <span class="star"> <i class="fa-solid fa-star"></i></span>
                        </div>
                        <div class="page-create-button">
                            <router-link to="/modules/funders/edit" class="btn-create">Create</router-link>
                        </div>
                        <div class="page-filter">
                            <input type="search" value="" placeholder="Searching..." class="form-control"
                                v-on:click="openAction">
                            <CustomSearch v-bind:class="{ active: isActive }" @searchEvent="childMethod"
                                @openAction="openAction"></CustomSearch>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <GenericList v-if="generic" ref="loadGeneric"></GenericList>
    </main>
</template>

<script>
    import { ref } from "vue";
    import breadcrumbs from "@/views/modules/Funders/MenuList.vue";
    import lang from "@/views/modules/Funders/language/en";
    import GenericList from "@/components/layout/shared/generic/ListView.vue";
    import CustomSearch from "@/views/modules/Funders/SearchView.vue";

    export default {
        name: "new-categorys",
        components: {
            breadcrumbs,
            GenericList,
            CustomSearch,
        },
        data() {
            return {
                generic: true,
                isActive: false,
                metaList: [
                    {
                        label: lang.LBL_NAME,
                        isSort: true,
                        field_name: 'name',
                        link: true,
                        moduleName: 'Funders',
                        routePath: 'funders',
                        linkOtherModule: false

                    },
                    {
                        label: lang.LBL_STATUS,
                        isSort: true,
                        field_name: 'status',

                    },
                ],
                columns: ['name', 'status'],
            }
        },
        mounted() {
            this.childMethod();
            this.$emit('MetaView', 'Awesome')
            let user = JSON.parse(localStorage.getItem('user_prefrence'));
        },
        methods: {
            childMethod(search = '') {
                if (this.generic == true) {
                    this.$refs.loadGeneric.loadGenericView(this.metaList, this.columns, search);
                }
            },
            openAction() {
                this.isActive = !this.isActive;
            },
        }
    }
</script>